import { useRef, useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const SIZE_MAP: any = {
  small: 100,
  medium: 160,
  large: 260,
};

const BORDER_MAP: any = {
  small: "#f2fff7",
  medium: "#cdffc4",
  large: "#98dded",
};

const Node = ({ node, size, isActive, onClick, onBlur }: { [key: string]: any }) => {
  const dimension = SIZE_MAP[size];
  const borderColor = BORDER_MAP[size];
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onBlur();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onBlur]);


  return (
    <Wrapper
      as={motion.div}
      onClick={onClick}
      ref={ref}
      initial={{ scale: 0.7 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      style={{
        width: dimension,
        height: dimension,
        borderColor,
      }}
    >
      {isActive ? (
        <video
          src={node.video}
          controls
          autoPlay
          loop
          style={{ width: "100%", height: "100%", borderRadius: "50%" }}
        />
      ) : (
        <img
          src={node.thumbnail}
          alt="node"
          style={{ width: "100%", height: "100%", borderRadius: "50%" }}
        />
      )}
    </Wrapper>
  );
};

export default Node;

const Wrapper = styled.div`
  border: 3px solid;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  cursor: pointer;
`;
